<template>
  <span class="svg-icon-arrow-chevron-down">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.19752 8.72008C4.49041 8.42719 4.96529 8.42719 5.25818 8.72008L11.1283 14.5895C11.6054 15.0666 12.3906 15.0666 12.8677 14.5895L18.7374 8.71967C19.0303 8.42678 19.5052 8.42678 19.7981 8.71967C20.091 9.01256 20.091 9.48744 19.7981 9.78033L13.9283 15.6501C12.8654 16.713 11.1306 16.713 10.0677 15.6501L4.19752 9.78074C3.90463 9.48785 3.90463 9.01297 4.19752 8.72008Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    isSolid: { type: Boolean },
  }
}
</script>